import { ApiResult } from "@/common/api/ApiResult.model";
import { ICONS } from "@/common/icons.map";
import { SharedState } from "@/common/state";
import { ApplicationType } from "@/views/customize/data-sources/data/model";
import { get_finding_count } from "@/common/api/findings/findings.api";

type SensitiveDataResult = Array<{
  id: string;
  count: number;
  name: string;
  icon: string;
}>;

export const get_sensitive_data_count_for_app = (
  app: ApplicationType
) => async (
  label_ids: string[],
  session_id: number
): Promise<ApiResult<SensitiveDataResult>> => {
  if (label_ids.length === 0) return { success: true, value: [] };
  const res = await get_finding_count({
    application: app,
    service: "msft_365",
    label_ids,
    type: "sensitive_information",
    axis_z: {
      type: "Session",
      value: session_id,
    },
  });
  if (res.success) {
    return {
      success: true,
      value: res.value.map(({ count, labelId }) => {
        const label = SharedState.allInfoTypes.value[labelId]!;
        return {
          id: labelId,
          count,
          name: label.labelName,
          icon: ICONS.L0_ICONS.get(label.code),
        };
      }),
    };
  } else {
    return res;
  }
};
